import { Author } from 'src/app/core/models/i-author';
import { ContentType } from '../../content-management/shared/enums/content-type';
import { ArticleTopic } from './i-article-topic';

export interface ISearchArticleRequest {
  pageNumber: number;
  pageSize: number;
  searchText?: string;
  articleStatuses?: string[];
  filterOnAuthors?: Author[];
  filterOnCreatedBy?: string;
  extendedSearch?: boolean;
  filterOnStartedEditingBy?: string;
  lastModifiedLowerBound?: Date;
  deliveryTargetCodeFilter?: string[];
  contentTypeFilter?: ContentType[];
  topicFilter?: ArticleTopic[];
  onlyReturnColumnistContent?: boolean;
  hideSpikedContent?: boolean;
  sortByPublishedDateDesc?: boolean;
}

export class SearchArticleRequest {
  constructor(
    public pageNumber: number = 1,
    public pageSize: number = 10,
    public searchText?: string,
    public articleStatuses: string[] = [],
    public filterOnAuthors: Author[] = [],
    public filterOnCreatedBy?: string,
    public extendedSearch?: boolean,
    public filterOnStartedEditingBy?: string,
    public lastModifiedLowerBound?: Date,
    public deliveryTargetCodeFilter: string[] = [],
    public contentTypeFilter: ContentType[] = [],
    public topicFilter: ArticleTopic[] = [],
    public onlyReturnColumnistContent?: boolean,
    public hideSpikedContent?: boolean,
    public sortByPublishedDateDesc?: boolean
  ) {}
}
